/* FIXME: use redux-toolkit and avoid a lot of the boiler-plate in reducers */
import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import caseSagas from './cases/saga';

export default function* rootSaga() {
  yield all([authSagas(), caseSagas()]);
}
